<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      size="small"
      :rules="rules"
      label-width="100px"
      class="form"
    >
      <el-form-item label="标题：" prop="title">
        <el-input placeholder="请输入标题" v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item
        label="内容："
        prop="content"
        required
        :show-message="showError"
      >
        <rich-text
          :detail.sync="ruleForm.content"
          @change-con="changeCon"
          uploadUrl="notice/richText"
        ></rich-text>
      </el-form-item>
      <el-form-item label="附件：">
        <upload
          ref="upload"
          :limit="10"
          :path="'notice/file'"
          v-model="ruleForm.attachmentList"
        />
      </el-form-item>
      <el-form-item style="text-align: center;">
        <el-button @click="reset">重置</el-button>
        <!-- <el-button @click="$router.back()">返回</el-button> -->
        <back-button :floatLeft="false" :pathOptions="pathOptions" />
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import richText from "@/components/RichText/index";
import { noticeSave, noticeUpdate } from "@/api/classNotice";
import rulesFactory from "@/utils/rules";
import Upload from "@/components/upload/index";
import BackButton from "@/components/backButton/index"

export default {
  components: {
    richText,
    Upload,
    BackButton
  },
  data() {
    return {
      ruleForm: {
        classId: "",
        title: "",
        content: "",
        attachment: "",
        attachmentList: []
      },
      showError: false,
      addTitle: "新增班级公告",
      editFlag: false,
      edituuid: "",
      pathOptions: {},
      rules: {
        title: [
          { required: true, message: "请输入公告标题", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50)
        ],
        content: [
          {
            required: true,
            message: "请输入公告内容"
          }
        ]
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.indexOf("/onlineClass/classNotice") != -1) {
        vm.pathOptions = {
          path: from.path,
          query: from.query
        }
      }
    });
  },
  created() {
    this.ruleForm.classId = this.$route.query.classId;
    if (this.$route.query.noticeDetail) {
      this.addTitle = "编辑班级公告";
      this.editFlag = true;
      let noticeDetail = this.$route.query.noticeDetail;
      this.ruleForm.title = noticeDetail.title;
      this.ruleForm.content = noticeDetail.content;
      this.ruleForm.onlineStatus = noticeDetail.onlineStatus;
      this.ruleForm.attachment = noticeDetail.attachment;
      this.edituuid = noticeDetail.uuid;
      this.ruleForm.attachmentList = JSON.parse(this.ruleForm.attachment);
    } else {
      this.addTitle = "新增班级公告";
      this.editFlag = false;
    }
  },
  methods: {
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (!this.ruleForm.content) {
          this.showError = true;
        }
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.ruleForm.attachment = JSON.stringify(
                this.ruleForm.attachmentList
              );
              if (this.editFlag) {
                this.ruleForm.uuid = this.edituuid;
                noticeUpdate(this.ruleForm).then(res => {
                  if (!res || res.code != 0) return;
                  this.$router.push(this.pathOptions);
                  this.$refs["ruleForm"].resetFields();
                });
              } else {
                this.ruleForm.onlineStatus = 0;
                noticeSave(this.ruleForm).then(res => {
                  if (!res || res.code != 0) return;
                  this.$router.push(this.pathOptions);
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    changeCon(data) {
      this.ruleForm.content = data;
      if (!this.ruleForm.content) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    cancel() {
      this.$router.back();
      this.$refs["ruleForm"].resetFields();
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.editFlag) {
          this.ruleForm.content = "";
          this.ruleForm.title = "";
        } else {
          this.ruleForm.content = "";
          this.$refs["ruleForm"].resetFields();
        }
      });
    }
  }
};
</script>
